import { Maybe } from 'src/types/maybe';
import { AudioProps, MediaProps } from 'src/templates/video-page-template/dto';
import { FFImageProps } from 'src/atoms/ff/ff-image';
import FFVideoCardProps from '../ff/ff-video-card/dto';
import { FFDocumentCardProps } from '../ff/ff-document-card';

export const calculateAllFilesSize = (
    videosDownloadSizes: number[] | undefined,
    additionalVideoFiles: Maybe<(FFVideoCardProps & MediaProps)[]>,
    additionalAudioFiles: Maybe<(AudioProps & MediaProps)[]>,
    additionalImageFiles: Maybe<(FFImageProps & MediaProps)[]>,
    additionalDocumentFiles: Maybe<(FFDocumentCardProps & MediaProps)[]>,
) => {
    let sum = 0;

    if (videosDownloadSizes) {
        sum += videosDownloadSizes.reduce((s, i) => (i ? s + i : s), 0);
    }

    if (additionalVideoFiles) {
        sum += additionalVideoFiles.reduce(
            (s, i) => (Number(i.fileSizeInBytes) ? s + Number(i.fileSizeInBytes) : s),
            0,
        );
    }

    if (additionalAudioFiles) {
        sum += additionalAudioFiles.reduce((s, i) => (i.size ? s + i.size : s), 0);
    }

    if (additionalImageFiles) {
        sum += additionalImageFiles.reduce((s, i) => (i.size ? s + i.size : s), 0);
    }

    if (additionalDocumentFiles) {
        sum += additionalDocumentFiles.reduce((s, i) => (i.download.size ? s + i.download.size : s), 0);
    }

    return sum;
};
